module.exports = __webpack_public_path__ + "img/com.codeway.cerebro_test-staging.a62085a7.png";